<template>
    <div class="energy_data_wrap">
        <StockData :menuList="menuList" @changeActive="changeActive" @changeItemActive="changeItemActive" :activeIndex="0">
            <div class='energy_data_content stock_detail' slot='stock_detail'>
                <div class='flex-center exchange_name'>
                    <div>{{ energy.name }}</div>
                </div>
                <div class='main_mid'>
                    <!-- 碳排放权 国内 | 国外 -->
                    <div v-if="energy.name == '碳排放-国内' || energy.name == '碳排放-国际'">
                        <div class='energy_info_text'>{{ energy.info }}</div>
                        <div class='data_card'>
                            <div v-if="energy.name == '碳排放-国内'" class='top_tips'>选择城市
                                <el-checkbox class='ml10' v-model='checkAll' @change='checkAllContract'>全选
                                </el-checkbox>
                            </div>
                            <div v-if="energy.name == '碳排放-国内'">
                                <el-checkbox-group v-model='checkList'>
                                    <el-checkbox :key='item.id' v-for='item in multiChoiceList' :label='item.id'>
                                        {{ item.title }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class='top_tips'>选择数据范围</div>
                            <div class='flex-center'>
                                <el-date-picker
                                    v-model='startDate'
                                    align='right'
                                    type='date'
                                    placeholder='选择日期'
                                    value-format='yyyy-MM-dd'
                                    :picker-options='pickerOptions'>
                                </el-date-picker>
                                <div>&nbsp;&nbsp;至&nbsp;&nbsp;</div>
                                <el-date-picker
                                    v-model='endDate'
                                    align='right'
                                    type='date'
                                    placeholder='选择日期'
                                    value-format='yyyy-MM-dd'
                                    :picker-options='pickerOptions'>
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <!-- 中国油价——汽柴油历史调价信息 -->
                    <div v-if="energy.name == '历史调价'">
                        <div class='energy_info_text'>{{ energy.info }}</div>
                        <div class='data_card'>
                            <div class='top_tips'>选择数据范围<span class='ml10'>* 年份可选范围为1896-2016年度</span>
                            </div>
                            <div class='flex-center'>
                                <el-date-picker
                                    v-model='startDate'
                                    align='right'
                                    type='date'
                                    placeholder='选择日期'
                                    value-format='yyyy-MM-dd'
                                    :picker-options='pickerOptions'>
                                </el-date-picker>
                                <div>&nbsp;&nbsp;至&nbsp;&nbsp;</div>
                                <el-date-picker
                                    v-model='endDate'
                                    align='right'
                                    type='date'
                                    placeholder='选择日期'
                                    value-format='yyyy-MM-dd'
                                    :picker-options='pickerOptions'>
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <!-- 中国油价——地区油价 -->
                    <div v-if="energy.name == '地区油价'">
                        <div class='energy_info_text'>{{ energy.info }}</div>
                        <div class='data_card'>
                            <div class='top_tips'>选择调价日</div>
                            <div class='flex-center'>
                                <el-date-picker
                                    v-model='selectYear'
                                    type='year'
                                    @change="selectMonth = (selectYear + '-01')"
                                    :picker-options='pickerOptions'
                                    value-format='yyyy'
                                    format='yyyy'
                                    placeholder='选择年'>
                                </el-date-picker>
                                <div>&nbsp;&nbsp;年&nbsp;&nbsp;</div>
                                <el-date-picker
                                    v-model='selectMonth'
                                    type='month'
                                    @change='getprovideDate'
                                    :picker-options='pickerOptions'
                                    format='yyyy-MM'
                                    value-format='yyyy-MM'
                                    placeholder='选择月'>
                                </el-date-picker>
                                <div>&nbsp;&nbsp;年&nbsp;&nbsp;</div>
                                <el-select v-model='selectDay'>
                                    <el-option v-for='item in dayArr' :key='item' :label='item'
                                               :value='item'></el-option>
                                </el-select>
                                <div>&nbsp;&nbsp;日&nbsp;&nbsp;</div>
                            </div>
                        </div>
                    </div>
                    <div class='but_btn' style='cursor: pointer'>
                        <div class='donload_btn' @click='queryTheData'>查询数据</div>
                        <div></div>
                    </div>
                </div>
                <!-- 数据预览-->
                <DataPreview
                    v-if='whetherToShowAPreview'
                    ref='dataPreview'
                    :down-load-data='downloadData'
                    api-url='/ms_resource/energy/preview'
                    :queryParameters='queryParameters'
                ></DataPreview>
            </div>
        </StockData>
    </div>
</template>
<script>
import { energyCity, energyMenu, provideDate } from '../../utils/api';

export default {
    data() {
        return {
            menuList: [],
            activeIndex: 1,
            checkAll: false,
            checkList: [],
            multiChoiceList: [],
            activeItemIndex: '',
            pickerOptions: {
                disabledDate(data) {
                        return data && data.valueOf() >= new Date()
                    }
            },
            selectYear: '',
            selectMonth: '',
            dayArr: [],
            selectDay: '',
            startDate: '',
            endDate: '',
            energy: {
                name: '地区油价',
                info: '返回指定日期范围内所选国内城市的碳情数据'
            },
            queryParameters: {},
            whetherToShowAPreview: true
        }
        },
        created(){
            this.getMenuList()
        },
        methods:{
            // 地区油价获取可选择日期
            getprovideDate(){
                let params = {
                    month:this.selectMonth.substring(this.selectMonth.length - 2),
                    year:this.selectYear
                }
                provideDate(params).then(res => {
                    this.dayArr = res.data;
                    this.selectDate = res.data[0];
                }).catch(err => {})
            },

            //目录改变。清除缓存
            clearCache() {
                this.startDate = '',
                    this.endDate = '',
                    this.selectDay = '',
                    this.checkAll = false,
                    this.checkList = [];
            },
            //预览数据
            queryTheData() {
                this.whetherToShowAPreview = true;
                // if(this.checkList.length===0) return this.$message.warning('请选择城市')
                if (!this.startDate || !this.endDate) return this.$message.warning('请选择时间区间');
                this.queryParameters = {
                    cityIds: this.checkList.join(','),
                    startDate: this.startDate,
                    endDate: this.endDate,
                    menuId: this.activeItemIndex,
                    date: this.selectDate ? `${this.selectMonth}-${this.selectDate}` : '2014-05-01'
                };
                setTimeout(() => {
                    this.$refs.dataPreview.queryTheData();
                });
            },
            //下载数据
            downloadData() {
                let params = {
                    cityIds: this.checkList,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    menuId: this.activeItemIndex,
                    date: this.selectDate ? `${this.selectMonth}-${this.selectDate}` : '2014-05-01'
                };
                let url = this.$core.setObjToUrlParams(this.$config.BASE_URL + '/energy/download', params);
                const loading = this.$loading({
                    lock:true,
                    text:'拼命加载中..',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                this.$core.downloadFileData('GET',url).then(res => {loading.close()}).catch(err => {loading.close()})
            },

            //获取外汇目录列表
            getMenuList(){
                energyMenu().then(res => {
                    this.menuList = res.data
                    this.activeIndex = res.data[0].id
                    this.activeItemIndex = res.data[0].subMenuList[0].id || ''
                    this.energy.name = res.data[0].subMenuList[0].title
                    this.energy.info = res.data[0].subMenuList[0].description
                    // 获取城市列表
                    energyCity({id:res.data[0].subMenuList[0].id}).then(res => {
                        this.multiChoiceList = res.data
                    }).catch(err => {})
                }).catch(err => {})
            },

            // 选择所有合约
            checkAllContract(val){
                this.checkList = val ? this.multiChoiceList.map(item => item.id) : [];
            },

            // el-submenu改变时获取index
            changeActive(index,item){
                this.whetherToShowAPreview = false;
                this.activeIndex = index;
            },

            // el-menu-item改变时操作
            changeItemActive(index,item){
                this.clearCache()
                this.energy.name = item.title
                this.energy.info = item.description
                this.activeItemIndex = index
            }
        },
    }
</script>
<style lang='scss' scoped>
.energy_info_text{
    margin: 25px auto 15px 0px;
    color: #999;
}
.top_tips{
    padding-left: 20px;
    font-size: 20px;
    position: relative;
    left: -30px;
    span{
        color: #999;
        font-size: 14px;
    }
}
.exchange_name{
    font-weight: bold;
    font-size: 24px;
    color: #271B63;
    i{
        font-size: 20px;
    }
}
.data_card{
    box-sizing: border-box;
    padding: 40px 120px;
    background: white;
    font-size: 18px;
    margin-top: 10px;
    border-radius: 10px 10px 0px 0px;
    /deep/td{
        border-bottom: 1px solid #e6e6e6;
        padding: 8px 0px !important;
    }
    .money_info{
        color: #b8b8b8;
        line-height: 1.7;
        font-size: 16px;
    }
    .filter_item{
        margin-bottom: 30px;
        flex-wrap: wrap;
        .select-item{
            min-width: 150px;

            font-size: 15px;
            display: flex;
            flex-direction: column;
            .country_name{
                margin: 10px 0px;
                color: #b8b8b8;
            }
        }

        .filter_title{
            color: #666666;
        }
    }
    /deep/.el-checkbox{
        margin-bottom: 15px;
    }
    /deep/.el-radio__label{
        font-size: 18px;
    }
}
.download-button{
    margin: 20px auto 0px 90px ;
}
.energy_data_content{
    width: 90%;
}
</style>
